import { Provider } from "@redotech/redo-order-common/provider";
import {
  GidType,
  parseGid,
  toGid,
} from "@redotech/redo-shopify-common/gid-utils";

/**
 * Derives the CRDB `order_tracking_order.source_order_id` key: gid for Shopify,
 * raw platform id otherwise. Every writer (Kafka consumer, both backfills) and
 * the tracking-page reader must share this or the exact-match lookup misses.
 *
 * Non-Shopify ids are opaque and must never be parsed — SFCC order numbers
 * carry both leading alpha and leading zeros (e.g. "B02759746").
 */
export function buildOrderTrackingSourceOrderId(
  source: Provider,
  platformOrderId: string,
): string {
  return source === Provider.SHOPIFY
    ? toGid(GidType.ORDER, platformOrderId)
    : platformOrderId;
}

/**
 * Inverse of {@link buildOrderTrackingSourceOrderId}: recovers the Mongo
 * `Order.shopify_id` value, matching the ingestion adapter's lookup exactly.
 */
export function parseOrderTrackingSourceOrderId(sourceOrderId: string): string {
  return parseGid(sourceOrderId);
}
